/**
 * isScrolledIntoView - detect if element is in view
 *
 * @param  {HTMLElement}  el - DOM element which is supposed to be in view
 * @return {Boolean} return true or false based of DOM element visibility in view
 */
export default function isScrolledIntoView(el = null) {
    if (!el) {
        return;
    }

    let boundingClient = el.getBoundingClientRect();

    let elemTop = boundingClient.top;
    let elemBottom = boundingClient.bottom;

    let isVisible = (elemTop >= 0) && (elemBottom <= (window.innerHeight / 2));
    return isVisible;
}



// WEBPACK FOOTER //
// ./src/main/js/utils/isScrolledIntoView.js